package web.fstech.onthecoffee

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.document
import kotlin.js.ExperimentalWasmJsInterop

@OptIn(ExperimentalComposeUiApi::class, ExperimentalWasmJsInterop::class)
fun main() {
    val container = document.getElementById("ComposeTarget") ?: document.body!!
    ComposeViewport(container) {
        App()
    }
}
